/**
 * AuthFormTitle Component
 *
 * A simple, reusable component to display the title and description
 * for authentication forms (e.g., login, signup, reset password).
 *
 * Features:
 * - Centers the title and description vertically and horizontally.
 * - Uses large, bold text for the main title and smaller, normal-weight text for the description.
 * - Fully reusable across different auth-related forms.
 *
 * Props (AuthFormTitleProps):
 * @param {string} title - The main title text to display (e.g., "Login").
 * @param {string} desc - A short description or subtitle under the title.
 *
 * Example Usage:
 * <AuthFormTitle
 *   title="Welcome Back"
 *   desc="Please login to your account to continue"
 * />
 */

import { AuthFormTitleProps } from "../../types/GeneralComponents";
const AuthFormTitle: React.FC<AuthFormTitleProps> = ({ title, desc }) => {
  return (
    <div className="flex flex-col justify-center">
      <h1 className="text-center text-4xl font-bold text-primaryMain">
        {title}
      </h1>
      <p className="text-center text-lg font-normal text-headingTextColor">
        {desc}
      </p>
    </div>
  );
};

export default AuthFormTitle;
